import { sendMSelection } from './m-messages';
/**
 * TextHighlight is a plugin that helps in rendering text highlight on pdf
 * call startHighlightPlugin to start the plugin
 * call stopHighlightPlugin to stop the plugin
 */
export function startHighlightPlugin(){
    // we may add a mouseup event listener to window here
    window.addEventListener("mouseup", mouseUpListener);
}

export function stopHighlightPlugin(){
    window.removeEventListener("mouseup", mouseUpListener);
}

function mouseUpListener(ev){
    getMSelection()
    .then((mSelection)=>{
        console.log("[@cruxcode/testpdfviewer] selection", mSelection);
        sendMSelection(mSelection);
    })
    .catch(()=>{
        console.log("[@cruxcode/testpdfviewer] some error occured during selection");
        sendMSelection(undefined);
    });
}
/**
 * @property {Object} map
 * 
 * map contains a mapping between page number and an array
 * this array contains all the MTextHighlight objects of the page
 */
const MTextHighlightStore = {
    map: {}
}

/**
 * @returns {Promise<MSelection>}
 */
export function getMSelection() {
    let promise = new Promise((resolve, reject)=>{
        let selection = window.getSelection();
        if (selection.isCollapsed) {
            reject();
            return;
        }
        let rangeCount = selection.rangeCount;
        let highlight = {
            ranges: [],
            textContent: selection.toString()
        };
        for (let i = 0; i < rangeCount; i++) {
            let range = selection.getRangeAt(i);
            let elements, startElement, endElement;
            if(range.startContainer.parentElement.nodeName == "SPAN"){
                startElement = range.startContainer.parentElement;
                // elements = getAllElements(range.startContainer.parentElement, range.endContainer.parentElement);
            } else if(range.startContainer.parentElement.nodeName == "DIV") {
                console.log("3_2", range.startContainer)
                startElement = range.startContainer;
                // elements = getAllElements(range.startContainer, range.endContainer);
            }
            if(range.endContainer.parentElement.nodeName == "SPAN"){
                endElement = range.endContainer.parentElement;
                // elements = getAllElements(range.startContainer.parentElement, range.endContainer.parentElement);
            } else if(range.endContainer.parentElement.nodeName == "DIV") {
                endElement = range.endContainer;
                // elements = getAllElements(range.startContainer, range.endContainer);
            }
            elements = getAllElements(startElement, endElement);
            if (!elements) {
                console.log("stopping highlight function. unhandled edge case.");
                reject();
                return;
            }
            let pageNumber = elements[0].parentElement.parentElement.getAttribute('data-page-number');
            let spans = getAllSpans(range, elements);
            highlight.ranges.push({
                pageNumber: pageNumber,
                spans: spans,
                startSpanNumber: elements[0].divNumber,
                endSpanNumber: range.endContainer.parentElement.divNumber,
                startSpanStartOffset: range.startOffset,
                endSpanEndOffset: range.endOffset
            });
        }
        resolve(highlight);
    });
    return promise;
}

function getAllElements(startElement, endElement) {
    // handling edge case of selection
    if (startElement.className == "page") {
        console.log("changing start element from page to first node. In future, disable selection for all elements outside pdf-viewer area.");
        console.log("For clarity on this contact @cruxcode");
        startElement = startElement.getElementsByClassName("textLayer")[0].childNodes[0];
        console.log("new startelement is", startElement);
    }
    if (startElement.parentElement.className != "textLayer") {
        console.log("inappropriate elements in selection");
        return null;
    }
    var elements = [startElement];
    var currentElement = startElement;
    while (true) {
        if (endElement == startElement) {
            break;
        }
        if (currentElement == endElement) {
            break;
        }
        if(currentElement.className == "endOfContent"){
            currentElement = currentElement.querySelector("span");
            if(!currentElement){
                break;
            }
            elements.push(currentElement);
        }
        if(!currentElement.nextElementSibling){
            break;
        }
        elements.push(currentElement.nextElementSibling);
        currentElement = currentElement.nextElementSibling;
    }
    return elements;
}

function getAllSpans(range, elements) {
    let spans = [];
    for (let i = 0; i < elements.length; i++) {
        let startOffset = 0;
        let endOffset = elements[i].childNodes[0].length;
        if (elements[i] == range.startContainer.parentElement) {
            startOffset = range.startOffset;
        }
        if (elements[i] == range.endContainer.parentElement) {
            endOffset = range.endOffset;
        }
        spans.push({
            spanNumber: elements[i].divNumber,
            startOffset: startOffset,
            endOffset: endOffset
        });
    }
    return spans;
}

/**
 * 
 * @param {MTextHighlight} highlight
 * @returns {Promise<MTextHighlight>}
 */
export function renderTextHighlight(highlight) {
    let promise = new Promise((resolve, reject)=>{
        let ranges = highlight.ranges;
        for (let i = 0; i < ranges.length; i++) {
            let pageNumber = highlight.ranges[i].pageNumber;
            let page = null;
            if (document.getElementsByClassName("page")[pageNumber - 1]) {
                page = document.getElementsByClassName("page")[pageNumber - 1];
            } else if (document.getElementsByClassName("page").length == 1) {
                page = document.getElementsByClassName("page")[0];
            }
            if (!page) {
                console.log("Page cannot be found. This error can occur if the page layout of pdf viewer is changed.");
                console.log("Currently it handles only two cases: one when there is only one page rendered at a time; second when scroll is used and all pages starting from 0 index are rendered.");
                console.log("For clarity on this contact @cruxcode");
                reject();
                return;
            }
            let textLayer = page.getElementsByClassName("textLayer")[0];
            let spans = highlight.ranges[i].spans;
            for (let j = 0; j < spans.length; j++) {
                let childNumber = spans[j].spanNumber - 1;
                let startOffset = spans[j].startOffset;
                let endOffset = spans[j].endOffset;
                let span = getStartSpan(textLayer, childNumber);
                let range = new Range();
                range.setStart(span.childNodes[0], startOffset);
                range.setEnd(span.childNodes[0], endOffset);
                let first = range.getClientRects()[0];
                let newDiv = document.createElement("div");
                newDiv.className = "highlight-overlay";
                newDiv.style.position = "absolute";
                newDiv.style.top = (first.top - page.getClientRects()[0].top - page.clientTop) + "px";
                newDiv.style.left = (first.left - page.getClientRects()[0].left - page.clientLeft) + "px";
                newDiv.style.height = first.height + "px";
                newDiv.style.width = first.width + "px";
                newDiv.style.background = highlight.color;
                newDiv.style.opacity = 0.4;
                page.appendChild(newDiv);
            }
        }
        resolve(highlight);
    });
    return promise;
}

function getStartSpan(textLayer, childNumber) {
    let divNumber = childNumber + 1;
    if (textLayer.childNodes.length < divNumber) {
        return searchPrevious(textLayer, childNumber);
    }
    if (textLayer.childNodes[childNumber].divNumber == divNumber) {
        return textLayer.childNodes[childNumber];
    }
    if (textLayer.childNodes[childNumber].divNumber < divNumber) {
        return searchForward(textLayer, childNumber);
    }
    if (textLayer.childNodes[childNumber].divNumber > divNumber) {
        return searchPrevious(textLayer, childNumber);
    }
    return fallbackSearch(textLayer, childNumber);
}

function searchPrevious(textLayer, childNumber) {
    let divNumber = childNumber + 1;
    let currentNode = textLayer.childNodes[childNumber];
    for (let i = 0; i < childNumber; i++) {
        currentNode = currentNode.previousSibling;
        if (currentNode.divNumber == divNumber) {
            return currentNode;
        }
    }
}

function searchForward(textLayer, childNumber) {
    let divNumber = childNumber + 1;
    let currentNode = textLayer.childNodes[childNumber];
    for (let i = 0; i < textLayer.childNodes.length - childNumber; i++) {
        currentNode = currentNode.nextSibling;
        if (currentNode.divNumber == divNumber) {
            return currentNode;
        }
    }
}

function fallbackSearch(textLayer, childNumber) {
    let divNumber = childNumber + 1;
    let currentNode = textLayer.childNodes[0];
    for (let i = 0; i < textLayer.childNodes.length; i++) {
        currentNode = currentNode.nextSibling;
        if (currentNode.divNumber == divNumber) {
            return currentNode;
        }
    }
}